import React from 'react';
import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { Cell, ChevronRightIcon } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import { closeInfoCard } from "../../../../store/infoCards/actions";
import { handleChangePopupStep } from "../InfoCardsModal/utils";
import { SupportInfoListIcon } from "../SupportInfoListIcon";
import { useButtonConfig } from "./hook/useButtonConfig";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _SupportInfoListItem = function _SupportInfoListItem(_ref) {
  var changePopup = _ref.changePopup,
    href = _ref.href,
    onClose = _ref.onClose,
    text = _ref.text,
    title = _ref.title,
    type = _ref.type;
  var _useButtonConfig = useButtonConfig({
      changePopup: changePopup,
      href: href,
      onClose: onClose,
      type: type
    }),
    buttonConfig = _useButtonConfig.buttonConfig,
    linkConfig = _useButtonConfig.linkConfig;
  return /*#__PURE__*/React.createElement(Cell, {
    actionIcon: /*#__PURE__*/React.createElement(ChevronRightIcon, null),
    buttonConfig: buttonConfig,
    className: cx('item'),
    leftSubtitle: text,
    leftTitle: title,
    linkConfig: linkConfig,
    logo: {
      icon: /*#__PURE__*/React.createElement(SupportInfoListIcon, {
        type: type
      })
    },
    "data-t-id": "components-SupportInfoListItem"
  });
};
var mapDispatchToProps = {
  changePopup: handleChangePopupStep,
  onClose: closeInfoCard
};
export var SupportInfoListItem = compose(connect(null, mapDispatchToProps))(_SupportInfoListItem);